import { FormField, fieldA11y } from '@/components/FormField';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import type { EnvVarFormApi } from './useEnvVarForm';

/** Description (always) and the version note (new variables only; it is kept in the audit trail with v1). */
export function EnvVarDetails({ form }: { form: EnvVarFormApi }) {
  const error = form.errorFor('description', true);
  return (
    <>
      <FormField id="env-var-description" label="Description" error={error}>
        <Input data-testid="env-var-description" value={form.values.description} onChange={(e) => form.patch({ description: e.target.value })} maxLength={500} placeholder="REST gateway endpoint" {...fieldA11y('env-var-description', error)} />
      </FormField>
      {!form.edit ? (
        <FormField id="env-var-note" label="Version note" hint="Kept in the audit trail with v1">
          <Textarea data-testid="env-var-note" value={form.values.note} onChange={(e) => form.patch({ note: e.target.value })} rows={2} maxLength={500} placeholder="Initial value from Bitbucket repository variables" />
        </FormField>
      ) : null}
    </>
  );
}
